module.exports = {"Type":"SendSMS","Disabled":true,"Output":true,"Fields":[{"label":"Phone Number","name":"name","serializeTo":"node"},{"label":"SMS Text","type":"multiline","name":"text","serializeTo":"q"},{"label":"Publisher visibility","type":"yesno","name":"publisher","defaultValue":"No"}],"Header":{"Color":"black","BackgroundColor":"gray","Text":null}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/SendSMS.json
// module id = 705
// module chunks = 0